import { useState, useCallback } from 'react';
import type { Spot, CreateSpotRequest } from '@ridehub/shared';
import { apiClient, ApiError } from '../../lib/api-client.js';

export function useSpotRegistration() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [duplicateWarning, setDuplicateWarning] = useState<string | null>(null);

  const register = useCallback(async (data: CreateSpotRequest): Promise<Spot | null> => {
    setLoading(true);
    setError(null);
    try {
      const spot = await apiClient.post<Spot>('/spots', data, { requireAuth: true });
      return spot;
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.code === 'CONFLICT_ERROR') {
          setDuplicateWarning(err.message);
        } else {
          setError(err.message);
        }
      } else {
        setError('スポットの登録に失敗しました');
      }
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    register,
    loading,
    error,
    duplicateWarning,
    clearWarning: () => setDuplicateWarning(null),
  };
}
